export default __webpack_public_path__ + "static/media/logo-dark.33134db6.webp";